module.exports = __webpack_public_path__ + "img/easy-spinach-pasta-salad.9081a4c4.jpg";